import { type IOverviewJointBillService } from "@services/overview/types";
import {
  type BeforePaymentAction,
  type PaymentRestrictionType,
} from "@services/payments/types";

export interface ICustomerDetails {
  accountId: string;
  firstName: string;
  lastName: string;
  email: string;
  billForwardEmail?: string;
  phone: string;
  hasFacebookLogin: boolean;
  facebookUserId?: string;
  hasAppleLogin: boolean;
  hasAcceptedMarketingRules: boolean;
  requiresOldPasswordWhenUpdatingPassword: boolean;
}

export interface ICustomerMetadata {
  cultureId: string;
  unreadMessagesCount: number;
  taxCollectorTypeId: string;
  requiresContactDataUpdate: boolean;
  jointBillServiceIdsRequiringContactSubmission: number[];
  requiresPasswordChange: boolean;
  marketingRulesAccepted: boolean;
  termsOfServiceAccepted: boolean;
  lastPasswordChangeDate: string;
  privacyPolicyAccepted: boolean;
  isNewlyRegistered: boolean;
  beforePaymentAction: BeforePaymentAction;
  paymentRestrictionTypeId: PaymentRestrictionType;
  showPaymentRestrictionNotification?: boolean;
  defaultPageIsBillsPage: boolean;
  isBlocked: boolean;
}

export interface IUpdateCustomerPasswordRequest {
  newPassword: string;
  oldPassword?: string;
}

export interface IUpdateFacebookConnectionRequest {
  facebookAccessToken: string | null;
}

export interface IUpdateAppleConnectionRequest {
  appleToken: string | null;
}

export interface ICustomerCreateRequestJointBillService {
  municipalityId: number;
  settlementId: number;
  streetId: number;
  houseNumber: string;
  apartmentNumber: string;
}

export interface ICreateCustomerRequest {
  e?: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  discountCode: string;
  password: string;
  rulesAccepted: boolean;
  marketingRulesAccepted: boolean;
  jointBillService?: ICustomerCreateRequestJointBillService;
  cultureId: string;
  circlewiseInformation?: {
    circlewiseId: string;
    circlewiseOfferSid: string;
  };
}

export interface IRemoveCustomerRequest {
  customerStateChangingReasonId?: number;
  comment: string;
}

export interface ICreateCustomerWithPermissionsRequest {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  customerServiceRelationRole: CustomerServiceRelationRole;
  jointBillServiceId: IOverviewJointBillService["jointBillServiceId"];
}

export interface IDeleteCustomerWithPermissionsRequest {
  jointBillServiceId: IOverviewJointBillService["jointBillServiceId"];
  customerId: number;
}

export interface ICustomerAgreement {
  termsOfServiceAccepted: boolean;
  marketingRulesAccepted: boolean;
}

export interface IUpdatePersonalInformationRequest {
  firstName: string;
  lastName: string;
  phoneNumber: string;
  email: string;
}

export interface IUpdateCustomerDetailsRequest {
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  email?: string;
  marketingRulesAccepted?: boolean;
  termsOfServiceAccepted?: boolean;
  privacyPolicyAccepted?: boolean;
  password?: string;
}

export enum CustomerServiceRelationRole {
  OWNER = "owner",
  PAYER = "payer",
}

export interface ICustomerRemoveReason {
  customerStateChangingReasonId: number;
  name: string;
  isCommentRequired: boolean;
}

export interface IGetSignUpPrefillDataRequest {
  e: string;
}

export interface IGetSignUpPrefillDataResponse {
  municipalityId: number;
  settlementId: number;
  streetId: number;
  houseNumber: string;
  apartmentNumber: string;
  email: string;
  firstName: string;
  lastName: string;
}
